var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSouthEast = function SvgSouthEast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "south_east_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#south_east_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 17 4.7 6.1a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275L17 15.6V10q0-.424.288-.712A.97.97 0 0 1 18 9q.424 0 .712.288Q19 9.575 19 10v8q0 .424-.288.712A.97.97 0 0 1 18 19h-8a.97.97 0 0 1-.713-.288A.97.97 0 0 1 9 18q0-.424.287-.712A.97.97 0 0 1 10 17z"
  }))));
};
export default SvgSouthEast;